import Immutable from 'immutable';
import * as types from './ApparelEditor.types';

const initialState = {
    templateCode: null,
    variables: {
        quantity: '',
        size: '',
        logo: '',
        managerClinicName: '',
        managerName: '',
        managerEmail: '',
        managerAddress: '',
        managerCity: '',
        managerState: '',
        managerZip: '',
        managerPhone: '',

        // UTH Unisex
        uth_unisex_position_full_front: 0,
        uth_unisex_position_full_back: 0,
        uth_unisex_position_left_chest: 0,
        uth_unisex_position_right_chest: 0,
        uth_unisex_position_sleeve: 0,
        uth_unisex_position_other: 0,
        uth_unisex_position_other_text: '',
        uth_unisex_ink_university_orange: 0,
        uth_unisex_ink_university_blue: 0,
        uth_unisex_ink_university_grey: 0,
        uth_unisex_ink_university_black_white: 0,
        uth_unisex_ink_gulf_blue: 0,
        uth_unisex_ink_mustard: 0,
        uth_unisex_ink_dark_sage: 0,
        uth_unisex_ink_dusty_lavender: 0,
        uth_unisex_shirt_color: '',
        uth_unisex_size_small: 0,
        uth_unisex_size_medium: 0,
        uth_unisex_size_large: 0,
        uth_unisex_size_xl: 0,
        uth_unisex_size_2xl: 0,
        uth_unisex_size_3xl: 0,
        uth_unisex_size_small_qty: '',
        uth_unisex_size_medium_qty: '',
        uth_unisex_size_large_qty: '',
        uth_unisex_size_xl_qty: '',
        uth_unisex_size_2xl_qty: '',
        uth_unisex_size_3xl_qty: '',
        uth_unisex_files: [],
    },
    apparelItem: null,
    fetching: false,
    addingToCart: false,
    persons: [],
    department: null,
    fetchingDepartment: false,
    checkingShirtsIndex: null,
    checkingShirts: false,
    personalizationEnabled: false,
    isFavorite: false,
    addingFavorite: false,
    checkingFavorite: false,
    savingWork: false,
    action: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_APPAREL_ITEM:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_APPAREL_ITEM_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['apparelItem'], action.payload)
                .toJS();

        case types.FETCH_APPAREL_ITEM_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.FETCH_DEPARTMENT:
            return state.setIn(['fetchingDepartment'], true).toJS();

        case types.FETCH_DEPARTMENT_SUCCESS:
            return state.setIn(['fetchingDepartment'], false)
                .setIn(['department'], action.payload)
                .toJS();

        case types.FETCH_DEPARTMENT_ERROR:
            return state.setIn(['fetchingDepartment'], false).toJS();

        case types.ADD_TO_CART:
            if (parseInt(action.payload) === 2) {
                return state.setIn(['savingWork'], true).toJS();
            }
            return state.setIn(['addingToCart'], true).toJS();

        case types.ADD_TO_CART_SUCCESS:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.ADD_TO_CART_ERROR:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();;

        case types.CHECK_SHIRTS:
            return state.setIn(['checkingShirts'], true)
                .setIn(['checkingShirtsIndex'], action.payload)
                .toJS();

        case types.CHECK_SHIRTS_SUCCESS:
            return state.setIn(['checkingShirts'], false)
                .updateIn(['persons'], (persons) => {
                    const newPersons = [...persons.toJS()];
                    newPersons[action.payload.index]['shirts'] = action.payload.shirts;
                    return newPersons;
                })
                .setIn(['checkingShirtsIndex'], null)
                .toJS();

        case types.CHECK_SHIRTS_ERROR:
            return state.setIn(['checkingShirts'], false)
                .setIn(['checkingShirtsIndex'], null)
                .toJS();

        case types.SET_TEMPLATE_CODE:
            return state.setIn(['templateCode'], action.payload).toJS();

        case types.SET_QUANTITY:
            return state.setIn(['variables', 'quantity'], action.payload).toJS();

        case types.SET_SIZE:
            return state.setIn(['variables', 'size'], action.payload).toJS();

        case types.SET_LOGO:
            return state.setIn(['variables', 'logo'], action.payload).toJS();

        case types.ADD_PERSON:
            return state.updateIn(['persons'], (persons) => {
                return persons.push(action.payload);
            }).toJS();

        case types.REMOVE_PERSON:
            return state.updateIn(['persons'], (persons) => {
                return persons.delete(action.payload);
            }).toJS();

        case types.SET_PERSON_FIELD:
            return state.updateIn(['persons'], (persons) => {
                const newPersons = [...persons.toJS()];
                newPersons[action.payload.personIndex][action.payload.fieldIndex] = action.payload.value;
                return newPersons;
            }).toJS();

        case types.SET_PERSON_QUANTITY:
            return state.updateIn(['persons'], (persons) => {
                const newPersons = [...persons.toJS()];
                newPersons[action.payload.personIndex]['quantities'][action.payload.quantityIndex] = action.payload.value;
                return newPersons;
            }).toJS();

        case types.INIT_PERSONS:
            return state.updateIn(['persons'], (persons) => {
                return [action.payload];
            }).toJS();

        case types.SET_MANAGER_CLINIC_NAME:
            return state.setIn(['variables', 'managerClinicName'], action.payload).toJS();

        case types.SET_MANAGER_NAME:
            return state.setIn(['variables', 'managerName'], action.payload).toJS();

        case types.SET_MANAGER_EMAIL:
            return state.setIn(['variables', 'managerEmail'], action.payload).toJS();

        case types.SET_MANAGER_ADDRESS:
            return state.setIn(['variables', 'managerAddress'], action.payload).toJS();

        case types.SET_MANAGER_CITY:
            return state.setIn(['variables', 'managerCity'], action.payload).toJS();

        case types.SET_MANAGER_STATE:
            return state.setIn(['variables', 'managerState'], action.payload).toJS();

        case types.SET_MANAGER_ZIP:
            return state.setIn(['variables', 'managerZip'], action.payload).toJS();

        case types.SET_MANAGER_PHONE:
            return state.setIn(['variables', 'managerPhone'], action.payload).toJS();

        case types.SET_PERSONALIZATION_ENABLED:
            return state.setIn(['personalizationEnabled'], action.payload).toJS();

        case types.ADD_FAVORITE:
            return state.setIn(['addingFavorite'], true).toJS();

        case types.ADD_FAVORITE_SUCCESS:
            return state.setIn(['addingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.type) === 1)
                .toJS();

        case types.ADD_FAVORITE_ERROR:
            return state.setIn(['addingFavorite'], false).toJS();

        case types.CHECK_FAVORITE:
            return state.setIn(['checkingFavorite'], true).toJS();

        case types.CHECK_FAVORITE_SUCCESS:
            return state.setIn(['checkingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.favorite) === 1)
                .toJS();

        case types.CHECK_FAVORITE_ERROR:
            return state.setIn(['checkingFavorite'], false).toJS();

        case types.SET_APPAREL_ITEM:
            return state.setIn(['apparelItem'], action.payload).toJS();

        case types.SET_DEPARTMENT:
            return state.setIn(['department'], action.payload).toJS();

        case types.SET_ACTION:
            return state.setIn(['action'], action.payload).toJS();

        case types.SET_FIELD:
            return state.setIn(['variables', action.payload.field], action.payload.value).toJS();

        case types.ADD_FILE:
            return state.updateIn(['variables', 'uth_unisex_files'], (files) => {
                return files.push(action.payload);
            }).toJS();

        case types.REMOVE_FILE:
            return state.updateIn(['variables', 'uth_unisex_files'], (files) => {
                return files.delete(action.payload);
            }).toJS();

        case types.CLEAR_FILES:
            return state.updateIn(['variables', 'uth_unisex_files'], (files) => {
                return files.clear();
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}